export default () => {
    const holicstvi = document.querySelector("body.id-763");
    
    if (holicstvi) {
        const currentCurrency = getShoptetDataLayer('currency');
        const currencyPrefix = {
        CZK: 'Kč',
        EUR: '€'
        };
        const reversedJson = [...barberJson].reverse();
        console.log(reversedJson);
        reversedJson.forEach((obj, boxIndex) => {
        const boxes = document.querySelector(".boxes");
        const box = `
                        <div class = "box box-${boxIndex + 1}">
                            <div class="box__top">
                                <h2>${obj.name}</h2>
                                <div class="image"><img src="${obj.img}" alt="${obj.name}"></div>
                            </div>
                            <div class="box__bottom">
                                
                            </div>
                        </div>
                `;
    
        if (boxes && obj.services) {
            boxes.insertAdjacentHTML("afterbegin", box);
            const currentBox = document.querySelector(`.box.box-${boxIndex + 1}`);
            const services = obj.services;
            services.forEach((service, serviceIndex) => {
            const item = `
                <div data-service-block-number="${boxIndex + 1}${serviceIndex + 1}" class="item item-${serviceIndex + 1}">
                    <div class="item__top">
                    <div class="item__head">
                        <h3 class="title">
                            ${service.name}
                            <br>
                            <div class="description ${!service.description || service.description.length === 0 ? 'is-empty' : ''}" data-description-open="${boxIndex + 1}${serviceIndex + 1}">
                            Popis
                            </div>
                        </h3>
                        <div class="pricing">
                            <div class="guest"><span>Běžná cena</span> <span class="price">${service.normalPrice[currentCurrency]} ${currencyPrefix[currentCurrency]}</span>
                        </div>
                        <div class="member">
                            <span>Club member</span>
                            <span class="price">${service.clubPrice[currentCurrency]} ${currencyPrefix[currentCurrency]}</span>
                        </div>
                    </div>
                </div>
                <div class="item__ctas">
                    <a class="club" href="${obj.club.link}">${obj.club.text}</a> 
                    <a class="reservation" href="${obj.reservation.link}" target="_blank">${obj.reservation.text}</a>
                </div>
                </div>
                <div class="item__description is-hide ${!service.description || service.description.length === 0 ? 'is-empty' : ''}">
                    ${service.description}
                </div>
                </div>
                `;
            currentBox.querySelector(".box__bottom").insertAdjacentHTML("beforeend", item);
            });
        }
    
        if (obj.info) {
            const box = `
                        <div class="box box-${boxIndex + 1}">
                            <div class="box__top--alter">
                            <h2>
                                ${obj.name}
                            </h2>
                            <div class="image"><img src="${obj.img}" alt="Barber produkty" /></div>
                            </div>
                            <div class="box__bottom">
                            <div class="text">
                            <p class="font--bold">${obj.info}</p>
                            <a class="cta" href="${obj.btn.link}">${obj.btn.text}</a>
                            </div>
                            </div>
                        </div>
                    `;
            boxes.insertAdjacentHTML("afterbegin", box);
            document.querySelector(`.box.box-${boxIndex + 1}`);
        }
        });
    
        const itemDescriptionsButtons = holicstvi.querySelectorAll('[data-description-open]');
    
        if (itemDescriptionsButtons) {
        itemDescriptionsButtons.forEach((itemDescriptionsButton) => {
            if (!itemDescriptionsButton.classList.contains('is-empty')) {
            const itemNumber = itemDescriptionsButton.getAttribute('data-description-open');
    
            if (itemNumber) {
                itemDescriptionsButton.addEventListener('click', () => {
                const itemBlock = holicstvi.querySelector(`[data-service-block-number="${itemNumber}"]`);
    
                if (itemBlock) {
                    const itemBlockDescription = itemBlock.querySelector('.item__description');
    
                    if (itemBlockDescription) {
                    itemBlockDescription.classList.toggle('is-hide');
                    }
                }
                });
            }
            }
        });
        }
    }
};






